module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/point03-a64408e55d91784d1aaaf3021d533094.png";